const elements = document.querySelectorAll('.js-metaobject-notice');
if (!elements.length > 0) return;
let currentIndex = 0;
function switchElements() {
  if (elements[currentIndex]) elements[currentIndex].classList.remove('active');
  currentIndex = (currentIndex + 1) % elements.length;
  if (elements[currentIndex]) elements[currentIndex].classList.add('active');
}
setInterval(switchElements, 2800);
